module.exports = __webpack_public_path__ + "img/ring_g_l_1_null.f722d425.png";